import { WrappedFieldInputProps } from 'redux-form'

export const getInputValue = (input?: Partial<WrappedFieldInputProps>) => {
  return !input || !input.value ? [] : input.value.split(',')
}
